import React from 'react';
import { MapPin, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { touristPlaces, companyInfo } from '../mockData';

const DestinationsSection = () => {
  const handleBookTaxi = (placeName) => {
    const message = `Hi, I want to book a taxi to ${placeName}`;
    window.open(`https://wa.me/91${companyInfo.phone[0]}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section id="destinations" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Explore <span className="text-orange-600">Uttar Pradesh</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Discover the spiritual and cultural heritage of Uttar Pradesh with our reliable taxi services
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {touristPlaces.map((place) => (
            <div
              key={place.id}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 hover:border-orange-200 transform hover:-translate-y-2"
            >
              {/* Place Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={place.image}
                  alt={place.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <h3 className="absolute bottom-4 left-4 text-2xl font-bold text-white">{place.name}</h3>
              </div>

              {/* Place Details */}
              <div className="p-6">
                <p className="text-gray-700 mb-4 leading-relaxed">{place.description}</p>

                {/* Highlights */}
                <div className="space-y-2 mb-6">
                  <p className="text-sm font-semibold text-gray-900 mb-2">Key Attractions:</p>
                  {place.highlights.map((highlight, index) => (
                    <div key={index} className="flex items-center text-sm text-gray-700">
                      <MapPin className="w-4 h-4 text-orange-600 mr-2 flex-shrink-0" />
                      {highlight}
                    </div>
                  ))}
                </div>

                {/* Book Taxi Button */}
                <Button
                  onClick={() => handleBookTaxi(place.name)}
                  className="w-full bg-orange-600 hover:bg-orange-700 text-white py-6 rounded-lg font-semibold shadow-md hover:shadow-lg transition-all"
                >
                  <Phone className="w-4 h-4 mr-2" />
                  Book Taxi
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DestinationsSection;
